<template>
  <ol class="flow">
    <li
      v-for="(item, i) in items"
      :key="i"
      :style="{ width: 100 / items.length + '%' }"
      :class="[
        'flow_item',
        { 'flow_item-current': i === current - 1 },
        { 'flow_item-passed': i < current - 1 }
      ]"
    >
      <span v-html="item.label"></span>
    </li>
  </ol>
</template>

<script lang="ts">
export default {
  name: 'Flow',

  props: {
    items: Array,
    current: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.flow {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.5;
  counter-reset: flow;
  margin-left: calc(-1 * (10% - 14px));
  margin-right: calc(-1 * (10% - 14px));

  @include mixins.media() {
    justify-content: center;
  }
}

.flow_item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #999;
  counter-increment: flow;

  @include mixins.media() {
    width: 124px !important;
  }

  > span {
    margin-top: 5px;
  }

  &::before {
    position: relative;
    z-index: 1;
    display: inline-block;
    content: counter(flow);
    width: 28px;
    height: 28px;
    border-radius: 100%;
    background-color: #ebebeb;
    color: #999;
    font-size: 1.2rem;
    line-height: 28px;

    @include mixins.media() {
      width: 32px;
      height: 32px;
      line-height: 30px;
      font-size: 1.8rem;
    }
  }

  &:not(:last-child)::after {
    z-index: 0;
    position: absolute;
    top: 13px;
    left: 100%;
    transform: translateX(-50%);
    display: inline-block;
    content: '';
    width: 100%;
    height: 4px;
    background-color: #f5f5f5;

    @include mixins.media() {
      top: 15px;
    }
  }
}

.flow_item-current {
  color: var.$color-main-text;

  &::before {
    background-color: var.$color-main;
    color: var.$color-white;
  }
}

.flow_item-passed {
  &::before,
  &:not(:last-child)::after {
    background-color: #d3d3d3;
  }
}
</style>
